// https://vuex.vuejs.org/en/actions.html

import userProfileService from '@/services/userProfileService'
import store from '@/store'

export default {
  async UpdateUserProfile (context, user, loadingMessage) {
    var loadingId = await store.dispatch('AddLoadingMessage', loadingMessage || 'Loading')
    var apiResult = await userProfileService.saveUser(user)
    if (apiResult.success) {
      context.commit('UpdateUser', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
